import axiosReports from "../../domain/configuration/axiosReportsV2";

export default class MetricsService {
  async getCatalog({ token, signal } = {}) {
    const { data } = await axiosReports.get("/metrics", {
      headers: { "X-Access-Token": token, authorization: `Bearer ${token}` },
      signal,
    });
    return data;
  }

  async getMetric({ name, filters = {}, token, signal } = {}) {
    const { data } = await axiosReports.get(`/metrics/${name}`, {
      headers: { "X-Access-Token": token, authorization: `Bearer ${token}` },
      params: filters,
      signal,
    });
    return data;
  }

  async getDashboards({ token, signal } = {}) {
    const { data } = await axiosReports.get("/dashboards", {
      headers: { "X-Access-Token": token, authorization: `Bearer ${token}` },
      signal,
    });
    return data;
  }

  async getCompanyConfig({ companyId, token, signal } = {}) {
    const { data } = await axiosReports.get(`/admin/company-config/${companyId}`, {
      headers: { "X-Access-Token": token, authorization: `Bearer ${token}` },
      signal,
    });
    return data;
  }

  async updateCompanyConfig({ companyId, patch, token, signal } = {}) {
    const { data } = await axiosReports.put(`/admin/company-config/${companyId}`, patch, {
      headers: { "X-Access-Token": token, authorization: `Bearer ${token}` },
      signal,
    });
    return data;
  }
}
